







































import { Component, Vue } from "vue-property-decorator";
import { reviewArticle, toReviewArticles } from "@/graphql/article";

@Component({
  apollo: {
    toReviewArticles() {
      return {
        query: toReviewArticles,
        skip: true,
        variables: { conference: "" },
      };
    },
  },
})
export default class ArticlesView extends Vue {
  get conference() {
    return this.$store.getters.getConferenceId;
  }

  async mounted() {
    const item = localStorage.getItem("conference");
    // @ts-ignore
    const _id = JSON.parse(item)._id;
    this.$apollo.queries.toReviewArticles.setVariables({
      conference: _id,
    });
    this.$apollo.queries.toReviewArticles.skip = false;
    await this.$apollo.queries.toReviewArticles.refetch();
  }

  async reviewArticle(_id: string, review: boolean) {
    const res = await this.$apollo.mutate({
      mutation: reviewArticle(this.conference, _id, review),
    });
    if (res) {
      alert("Review Submitted!");

      const item = localStorage.getItem("conference");
      // @ts-ignore
      const _id = JSON.parse(item)._id;
      this.$apollo.queries.toReviewArticles.setVariables({
        conference: _id,
      });
      this.$apollo.queries.toReviewArticles.skip = false;
      await this.$apollo.queries.toReviewArticles.refetch();
    } else alert("an error has occured");
  }
}
